import { onLinkClick } from '../app/router.js';
import { useT } from '../i18n/index.js';
import { useRewards } from '../state/rewards.js';
import { BadgeMedal, ProfileIcon } from './RewardIcons.js';
import { LevelBar } from './RewardsUi.js';

/** "Your progress" on the home page: level, streak, newest badges. */
export function ProgressCard() {
  const t = useT();
  const s = useRewards();
  if (!s) return null;
  const newest = [...s.badges].sort((a, b) => b.at.localeCompare(a.at)).slice(0, 5);
  return (
    <section className="card side-card progress-card" aria-labelledby="progress-title">
      <div className="side-card-head">
        <h2 id="progress-title">{t.rewards.title}</h2>
        <span className="progress-level">
          <ProfileIcon id={s.equipped.icon} size={16} />
          {t.rewards.level(s.level)}
        </span>
      </div>
      <strong className="progress-points">{t.rewards.points(s.points)}</strong>
      <LevelBar s={s} />
      <p className="progress-streak">
        🔥 {t.rewards.streakDays(s.streak.current)} ·{' '}
        {s.streak.today ? t.rewards.todayDone : t.rewards.todayOpen}
      </p>
      {newest.length > 0 && (
        <div className="progress-badges">
          {newest.map((b) => (
            <span key={b.id} title={t.rewards.badge[b.id]?.[0] ?? b.id}>
              <BadgeMedal id={b.id} earned size={32} />
            </span>
          ))}
        </div>
      )}
      <a href="/me" onClick={onLinkClick} className="progress-link">
        {t.rewards.seeAll} →
      </a>
    </section>
  );
}
